import { useState } from 'react';
import { DivProps } from 'react-html-props';
import { LuX } from 'react-icons/lu';
import styled from 'styled-components';

interface Props {
    variant: 'blue' | 'yellow';
    className?: string;
    text: string;
    isClosable?: boolean;
    onHide?: () => void;
}

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    border-radius: 0.75rem;

    svg {
        width: 1.25rem;
        height: 1.25rem;
    }

    p {
        font-family: 'Hero New';
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    button {
        display: flex;
        border: none;
        background: none;
        cursor: pointer;
    }

    &.yellow {
        background: #ffeda6;
        color: #453b1e;

        svg {
            color: #453b1e;
        }
    }

    &.blue {
        background: #bfe0fb;
        color: #1e2545;
        svg {
            color: #1e2545;
        }
    }
`;

export const WarnNotice = ({
    variant,
    className,
    text,
    isClosable,
    onHide,
}: Props & DivProps) => {
    const [isVisible, setVisible] = useState(true);

    if (!isVisible) return null;

    return (
        <Container className={(className ?? '') + ' ' + variant}>
            <p className="text">{text}</p>
            {isClosable && (
                <button
                    onClick={() => {
                        if(onHide) onHide();
                        setVisible(e => !e);
                    }}
                >
                    <LuX />
                </button>
            )}
        </Container>
    );
};

export const WarnNoticeSeparator = styled.div`
    border-radius: 6.1875rem;
    background: var(--Neutral-300, #d4d4d8);
    align-self: stretch;
    height: 0.125rem;
`;
